import axios from 'axios'
import store from '@/store'
import util from '@/util/util.js'
import { goldenpipeServer } from '@/assets/js/base-url.js'
import { Message, MessageBox } from 'element-ui';

const AUTH_LOG_PREFIX = '[AUTH_EXPIRE_CHECK]';
const AUTH_STORAGE_KEYS = [
  'user',
  'code',
  'userInfo',
  'username',
  'roles',
  'allRoles',
  'currentRole',
  'apiKey',
  'subscriptionKey',
  'authType',
  'currentOrg',
  'orgnameList',
  'userOrgList',
  'current_delegation',
  'delegateList',
  'expires_in',
  'source_login',
  'resetLogin',
  'login_time',
  'recent_user_time'
];

let loginExpiredAlertVisible = false;

function getStoredUserInfo() {
  try {
    const userInfo = window.localStorage.getItem('userInfo');
    return userInfo ? JSON.parse(userInfo) : null;
  } catch (error) {
    console.warn(AUTH_LOG_PREFIX, 'Failed to parse userInfo from localStorage', error);
    return null;
  }
}

function getCurrentAccessToken() {
  const userInfo = getStoredUserInfo();
  return userInfo && userInfo.access_token;
}

function getHeaderValue(headers, name) {
  if (!headers) {
    return '';
  }
  return headers[name] || headers[name.toLowerCase()] || headers[name.toUpperCase()] || '';
}

function getRequestAccessToken(config) {
  if (!config) {
    return '';
  }
  const authorization = getHeaderValue(config.headers, 'Authorization');
  if (authorization) {
    return String(authorization).replace(/^Bearer\s+/i, '');
  }
  return config.__authToken || '';
}

function maskToken(token) {
  if (!token) {
    return '';
  }
  const tokenText = String(token);
  if (tokenText.length <= 12) {
    return tokenText;
  }
  return `${tokenText.slice(0, 6)}...${tokenText.slice(-6)}`;
}

function getLoginAgeMs() {
  const loginTime = Number(window.localStorage.getItem('login_time'));
  return loginTime ? new Date().getTime() - loginTime : null;
}

function getRequestUrl(error) {
  return (error && error.config && error.config.url) || '';
}

function stripQuery(url) {
  return url ? String(url).split('?')[0] : '';
}

function isCmrAuthEndpoint(url) {
  return url.indexOf('/v1/userAuthorizationLogin') !== -1 || url.indexOf('/v1/refreshToken') !== -1;
}

function clearAuthStorage() {
  AUTH_STORAGE_KEYS.forEach(key => window.localStorage.removeItem(key));
}


//请求拦截器
axios.interceptors.request.use(config => {
  let conf = config;
  conf.headers = conf.headers || {};
  try {
    // 获取当前代理人信息
    window.localStorage.getItem("current_delegation");
    let current_delegation = JSON.parse( window.localStorage.getItem("current_delegation"));
    if (current_delegation && Object.keys(current_delegation).length) {
      // 设置代理信息请求头
      conf.headers["DELEGATED-USERNAME"] = current_delegation["DELEGATED-USERNAME"];
      conf.headers["DELEGATED-ROLE"] = current_delegation["DELEGATED-ROLE"];
    } else {
      // 移除代理相关请求头
      delete conf.headers["DELEGATED-USERNAME"];
      delete conf.headers["DELEGATED-ROLE"];
    }
  } catch (error) {
    console.log(error, "设置代理人请求头出错");
  }
  const userInfo = getStoredUserInfo();
  conf.__authToken = userInfo && userInfo.access_token;
  conf.__authStartedAt = new Date().getTime();
  return conf
}, error => {
  return Promise.reject(error)
});

//响应拦截器即异常处理
axios.interceptors.response.use(resp => {
  // TODO: CMR 登录接口后端无法返回响应体，避免warning提醒，过滤此接口拦截处理。
  if (resp.config.url.indexOf("v1/userAuthorizationLogin") == -1) {
    if (resp.data != null && resp.data.success !== undefined && !resp.data.success) {
      try {
        console.log({message: resp.data.err_message, url: resp.config.url.split("?")[0]});
      } catch (error) {
        
      }
      Message({
        showClose: true,
        message: 'Failed: ' + (resp.data.err_message || resp.data.errMessage),
        type: 'warning',
        duration: 8000
      })
    }
  }
  // 集成d1需要做的处理
  return resp.data.data ? resp.data : resp;
}, error => {
  if (error && error.response) {
    switch (error.response.status) {
      case 401: {
        const requestUrl = getRequestUrl(error);
        const requestAccessToken = getRequestAccessToken(error.config);
        const currentAccessToken = getCurrentAccessToken();
        const requestStartedAt = error.config && error.config.__authStartedAt;
        console.warn(AUTH_LOG_PREFIX, '401 received', {
          url: stripQuery(requestUrl),
          requestToken: maskToken(requestAccessToken),
          currentToken: maskToken(currentAccessToken),
          isSameToken: requestAccessToken && currentAccessToken ? requestAccessToken === currentAccessToken : null,
          requestAgeMs: requestStartedAt ? new Date().getTime() - requestStartedAt : null,
          loginAgeMs: getLoginAgeMs(),
          authType: window.localStorage.getItem('authType')
        });

        if (requestAccessToken && currentAccessToken && requestAccessToken !== currentAccessToken) {
          console.warn(AUTH_LOG_PREFIX, 'Ignore 401 from stale request token', {
            url: stripQuery(requestUrl)
          });
          break;
        }

        if (isCmrAuthEndpoint(requestUrl)) {
          console.warn(AUTH_LOG_PREFIX, 'Ignore global logout for CMR auth endpoint 401', {
            url: stripQuery(requestUrl)
          });
          break;
        }

        if (loginExpiredAlertVisible) {
          console.warn(AUTH_LOG_PREFIX, 'Ignore duplicated login expired alert', {
            url: stripQuery(requestUrl)
          });
          break;
        }

        loginExpiredAlertVisible = true;
        // window.localStorage.removeItem('user');
        // window.localStorage.removeItem('code');
        //window.localStorage.removeItem('userInfo');
        //router.push('/login');
        clearAuthStorage();
        MessageBox.alert('', '', {
          confirmButtonText: '确定',
          showClose:false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          title:"提示",
          message: "您登录已过期，请重新登录",
          callback: action => {
            loginExpiredAlertVisible = false;
            location.href = '/login';
          }
        });
        break;
      }
        // let message = error.response.data.message;
        // if (message && message.indexOf("token") !== -1) {
        //   window.localStorage.clear();
        //   location.href = '/login';
        // } else {
        //   break;
        // }



      //其他错误码

      default:
        // let errorArr = error.response.data.errors;
        // if(errorArr != null && errorArr.length > 0){
        // 	let errorMessage = "code:" + errorArr[0].code + ", message:" + errorArr[0].message;
        // 	 Message.warning('请求错误: ' + errorMessage);
        // }
        if (error.response.data != null && error.response.data.success !== undefined && !error.response.data.success) {
          try {
            console.log({message: error.response.data.message, url: error.config.url.split("?")[0]});
          } catch (error) {
            
          }
          Message({
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: 'Failed: ' + (error.response.data.err_message || error.response.data.errMessage),
            type: 'warning',
            duration: 8000
          })
        } else if (error.response.data != null && error.response.data.message) {
          try {
            console.log({message: error.response.data.message, url: error.config.url.split("?")[0]});
          } catch (error) {
            
          }
          Message({
            showClose: true,
            message: 'Failed: ' + error.response.data.message,
            type: 'warning',
            duration: 8000
          })
        } else if (error.response.data != null && error.response.data.errors != null && error.response.data.errors.length > 0) {
          try {
            console.log({message: error.response.data.errors[0].message, url: error.config.url.split("?")[0]});
          } catch (error) {
            
          }
          Message({
            showClose: true,
            message: 'Failed: ' + error.response.data.errors[0].message,
            type: 'warning',
            duration: 8000
          })
        }

      // Message.warning('HTTP请求返回错误码: ' + error.message);

    }
  } else {
    if (!(error.message.key && error.message.key === "cancel")) {
      Message({
        showClose: true,
        message: 'HTTP请求出错: ' + error.message,
        type: 'error',
        duration: 8000
      })
    }
  }

  return Promise.reject(error)
})


//axios全局设定
let baseUrl = '';
//读取系统环境变量
if (process.env.NODE_ENV.trim() === 'production') {
  baseUrl = window.BaseConfigInfo.baseSSO.domainName;
}

axios.defaults.baseURL = baseUrl

axios.defaults.headers = {
  'X-Requested-With': 'XMLHttpRequest'
}

// axios.defaults.withCredentials = true

//单位毫秒
axios.defaults.timeout = 1000  * 60 * 15

const downloadUrl = url => {
  let iframe = document.createElement('iframe');
  iframe.style.display = 'none'
  iframe.src = url
  iframe.onload = function () {
    document.body.removeChild(iframe)
  }
  document.body.appendChild(iframe)
}

function exchangeXROLENAME(url) {
  let currentRole = window.localStorage.getItem('currentRole');
  let allRoles = JSON.parse(window.localStorage.getItem('allRoles'));
  let XROLENAME = null;
  for (const key in allRoles) {
    if (key === currentRole) {
      XROLENAME = allRoles[key];
      break;
    }
  }
  for (let item of goldenpipeServer) {
    // 为CMR 转换 role 的 key 和 label
    if (url.indexOf(item) !== -1) {
      XROLENAME = currentRole;
      break;
    }
  }
  return XROLENAME;
}

    //处理ie浏览器的url兼容问题
    function IEBrowserUrl(url){
      let isTrident = navigator.userAgent.indexOf('Trident')>-1//判断是否是ie浏览器
      //console.log(isTrident)
        // return encodeURI(url)
        return url
    }

function fileDownload(res){
  const blob = new Blob([res.data]); // 将返回的数据通过Blob的构造方法，创建Blob对象
  const navigator = window.navigator;
  const _filename = res.headers['content-disposition'].split('=')[1];
  const filename = decodeURI(_filename);
  if ('msSaveOrOpenBlob' in navigator) {
    navigator.msSaveOrOpenBlob(blob, filename); // 针对浏览器
  } else {
    const elink = document.createElement('a'); // 创建a标签
    elink.download = filename;
    elink.style.display = 'none';
    // 创建一个指向blob的url，这里就是点击可以下载文件的根结
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); //移除链接
    document.body.removeChild(elink); //移除a标签
  }
}
export default {
  //用于d1请求的
  _get(url,params){
    
    // console.log(url,params,'======>')
    params = params == null ? {} : params;
    url += (url.indexOf("?") !== -1) ? "&" : "?";
    url += "api_key=" + window.localStorage.getItem('apiKey');
    url += '&timestamp=' + new Date().toISOString().replace('T', ' ').slice(0, -5);
    url += '&nonce_str=' + util.generateUUID();
    url += '&sign=' + util.d1GenerateGetSign(params, url);
    url = util.d1EncodeSplitParams(url,params);
    let headerParam = {};

    let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
      headerParam.Authorization = 'Bearer ' + userInfo.access_token;

    //headerParam.Authorization = 'Bearer ' + userInfo.access_token;
    headerParam["REQUEST-ID"] = util.generateUUID();
    headerParam["X-USERNAME"] = userInfo.username;
    headerParam["Ocp-Apim-Subscription-Key"] = util.decrypt(window.localStorage.getItem('subscriptionKey'));
    headerParam["Auth-Type"] = window.localStorage.getItem('authType');
    headerParam["appKey"] = window.BaseConfigInfo.baseSSO.appKey;
    headerParam["X-ROLENAME"] = exchangeXROLENAME(url);
    headerParam["X-ORG"] = window.localStorage.getItem('currentOrg');
    headerParam["X-SURROGATE"] = this.matchSurrogate(window.localStorage.getItem('userOrgList'), window.localStorage.getItem('currentOrg'));

    if (url.startsWith('./') || url.startsWith('../')) {
      //请求本地
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: IEBrowserUrl(url),
          withCredentials: false,
          baseURL: ''
        }).then(resp => {
          resolve(resp)
        }).catch(error => {
          reject(error)
        })
      })
    } else {
      //请求远端
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: IEBrowserUrl(url),
          withCredentials: false,
          headers: headerParam
        }).then(resp => {
          resolve(resp)
        }).catch(error => {
          reject(error)
        })
      })
    }
  },

  //get请求

  get(url, params,  cancelToken = null) {
    url += (url.indexOf("?") !== -1) ? "&" : "?";
    url += "api_key=" + window.localStorage.getItem('apiKey');
    url += '&timestamp=' + new Date().toISOString().replace('T', ' ').slice(0, -5);
    url += '&nonce_str=' + util.generateUUID();
    params = params == null ? {} : params;
    // params.token = 'PgTT0stft9qA7JGJp7f0oWT7j7pJ046j'

    url += '&sign=' + util.generateGetSign(params, url);

    url = util.encodeSplitParams(url, params);

    let headerParam = {};

    let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));

    headerParam.Authorization = 'Bearer ' + userInfo.access_token;
    headerParam["REQUEST-ID"] = util.generateUUID();
    headerParam["X-USERNAME"] = userInfo.username;
    headerParam["Ocp-Apim-Subscription-Key"] = util.decrypt(window.localStorage.getItem('subscriptionKey'));
    headerParam["Auth-Type"] = window.localStorage.getItem('authType');
    headerParam["appKey"] = window.BaseConfigInfo.baseSSO.appKey;
    headerParam["X-ROLENAME"] = exchangeXROLENAME(url);
    headerParam["X-ORG"] = window.localStorage.getItem('currentOrg');
    headerParam["X-SURROGATE"] = this.matchSurrogate(window.localStorage.getItem('userOrgList'), window.localStorage.getItem('currentOrg'));

    if (url.startsWith('./') || url.startsWith('../')) {
      //请求本地
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: IEBrowserUrl(url),
          withCredentials: false,
          baseURL: ''
        }).then(resp => {
          resolve(resp)
        }).catch(error => {
          reject(error)
        })
      })
    } else {
      //请求远端
      let httpParam = {
        method: 'get',
        url: IEBrowserUrl(url),
        withCredentials: false,
        headers: headerParam
      };
      if (cancelToken) {
        httpParam["cancelToken"] = cancelToken;
      }
      return new Promise((resolve, reject) => {
        axios(httpParam).then(resp => {
          resolve(resp)
        }).catch(error => {
          reject(error)
        })
      })
    }
  },

   // get file
   getFile(url, params) {
    url += (url.indexOf("?") !== -1) ? "&" : "?";
    url += "api_key=" + window.localStorage.getItem('apiKey');
    url += '&timestamp=' + new Date().toISOString().replace('T', ' ').slice(0, -5);
    url += '&nonce_str=' + util.generateUUID();
    params = params == null ? {} : params;
    // params.token = 'PgTT0stft9qA7JGJp7f0oWT7j7pJ046j'

    url += '&sign=' + util.generateGetSign(params, url);

    url = util.encodeSplitParams(url, params);

    let headerParam = {};

    let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    // if (window.baseSSO.environment !== 'local') {
    //   headerParam.Authorization = 'Bearer ' + userInfo.access_token;
    // }
    headerParam.Authorization = 'Bearer ' + userInfo.access_token;
    headerParam["REQUEST-ID"] = util.generateUUID();
    headerParam["X-USERNAME"] = userInfo.username;
    headerParam["Ocp-Apim-Subscription-Key"] = util.decrypt(window.localStorage.getItem('subscriptionKey'));
    headerParam["Auth-Type"] = window.localStorage.getItem('authType');
    headerParam["appKey"] = window.BaseConfigInfo.baseSSO.appKey;
    headerParam["X-ROLENAME"] = window.localStorage.getItem('currentRole');
    headerParam["X-ORG"] = window.localStorage.getItem('currentOrg');
    headerParam["X-SURROGATE"] = this.matchSurrogate(window.localStorage.getItem('userOrgList'), window.localStorage.getItem('currentOrg'));

    if (url.startsWith('./') || url.startsWith('../')) {
      //请求本地
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: IEBrowserUrl(url),
          withCredentials: false,
          baseURL: '',
          responseType: 'blob'
        }).then(resp => {
          resolve(resp)
        }).catch(error => {
          reject(error)
        })
      })
    } else {
      //请求远端
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: IEBrowserUrl(url),
          withCredentials: false,
          headers: headerParam,
          responseType: 'blob'
        }).then(resp => {
          resolve(resp)
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  
  //post请求
  post(url, data, params = {}, cancelToken = null) {
    params = util.deepClone(params);
    url += (url.indexOf("?") !== -1) ? "&" : "?";
    url += "api_key=" + window.localStorage.getItem('apiKey');
    url += '&timestamp=' + new Date().toISOString().replace('T', ' ').slice(0, -5);
    url += '&nonce_str=' + util.generateUUID();
    // url = util.splitUrl(params, url);
    params.sign = util.generatePostJsonSign(params, url, data);


    url = util.encodeSplitUrl(url);
    //生成sign后删除token
    delete params.token;
    let headerParam = {};
    headerParam["content-type"] = 'application/json;charset=UTF-8';
    let userInfo = window.localStorage.getItem('userInfo');
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      // if (window.baseSSO.environment !== 'local') {
      //   headerParam.Authorization = 'Bearer ' + userInfo.access_token;
      // }
      headerParam.Authorization = 'Bearer ' + userInfo.access_token;
      headerParam["X-USERNAME"] = userInfo.username;
    } else {
      headerParam["X-USERNAME"] = window.localStorage.getItem('username');
    }
    headerParam["REQUEST-ID"] = util.generateUUID();
    headerParam["Ocp-Apim-Subscription-Key"] = util.decrypt(window.localStorage.getItem('subscriptionKey'));
    headerParam["Auth-Type"] = window.localStorage.getItem('authType');
    headerParam["appKey"] = window.BaseConfigInfo.baseSSO.appKey
    headerParam["X-ROLENAME"] = exchangeXROLENAME(url);
    headerParam["X-ORG"] = window.localStorage.getItem('currentOrg');
    headerParam["X-SURROGATE"] = this.matchSurrogate(window.localStorage.getItem('userOrgList'), window.localStorage.getItem('currentOrg'));
   
    let httpParam = {
      method: 'post',
      url: IEBrowserUrl(url),
      withCredentials: false,
      params: params,
      data: data,
      headers: headerParam
    };
    if (cancelToken) {
      httpParam["cancelToken"] = cancelToken;
    }
    return new Promise((resolve, reject) => {
      axios(httpParam).then(resp => {
        resolve(resp)
      }).catch(error => {
        reject(error)
      })
    })
  },
  put(url, data, params) {
    params = params == null ? {} : params;
    params = util.deepClone(params);
    url += (url.indexOf("?") !== -1) ? "&" : "?";
    url += "api_key=" + window.localStorage.getItem('apiKey');
    url += '&timestamp=' + new Date().toISOString().replace('T', ' ').slice(0, -5);
    url += '&nonce_str=' + util.generateUUID();

    params.sign = util.generatePostJsonSign(params, url, data);


    url = util.encodeSplitUrl(url);
    //生成sign后删除token
    delete params.token;
    let headerParam = {};
    headerParam["content-type"] = 'application/json;charset=UTF-8';
    let userInfo = window.localStorage.getItem('userInfo');
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      // if (window.baseSSO.environment !== 'local') {
      //   headerParam.Authorization = 'Bearer ' + userInfo.access_token;
      // }
      headerParam.Authorization = 'Bearer ' + userInfo.access_token;
      headerParam["X-USERNAME"] = userInfo.username;
    } else {
      headerParam["X-USERNAME"] = window.localStorage.getItem('username');
    }
    headerParam["REQUEST-ID"] = util.generateUUID();
    headerParam["Ocp-Apim-Subscription-Key"] = util.decrypt(window.localStorage.getItem('subscriptionKey'));
    headerParam["Auth-Type"] = window.localStorage.getItem('authType');
    headerParam["appKey"] = window.BaseConfigInfo.baseSSO.appKey
    headerParam["X-ROLENAME"] = exchangeXROLENAME(url);
    headerParam["X-ORG"] = window.localStorage.getItem('currentOrg');
    headerParam["X-SURROGATE"] = this.matchSurrogate(window.localStorage.getItem('userOrgList'), window.localStorage.getItem('currentOrg'));

    return new Promise((resolve, reject) => {
      axios({
        method: 'put',
        url: IEBrowserUrl(url),
        withCredentials: false,
        params: params,
        data: data,
        headers: headerParam
      }).then(resp => {
        resolve(resp)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //delete请求
  delete(url, data, params) {
    params = params == null ? {} : params;
    params = util.deepClone(params);
    params.api_key = window.localStorage.getItem('apiKey');
    // params.token='PgTT0stft9qA7JGJp7f0oWT7j7pJ046j';
    params.timestamp = new Date().toISOString().replace('T', ' ').slice(0, -5);
    params.nonce_str = util.generateUUID();
    params.sign = util.generatePostJsonSign(params, url, data);
    url = util.splitUrl(params, url);
    //生成sign后删除token
    delete params.token;
    let headerParam = {};
    let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    // if (window.baseSSO.environment !== 'local') {
    //   headerParam.Authorization = 'Bearer ' + userInfo.access_token;
    // }
    headerParam.Authorization = 'Bearer ' + userInfo.access_token;
    headerParam["content-type"] = 'application/json;charset=UTF-8';
    headerParam["REQUEST-ID"] = util.generateUUID();
    headerParam["X-USERNAME"] = userInfo.username;
    headerParam["Ocp-Apim-Subscription-Key"] = util.decrypt(window.localStorage.getItem('subscriptionKey'));
    headerParam["Auth-Type"] = window.localStorage.getItem('authType');
    headerParam["appKey"] = window.BaseConfigInfo.baseSSO.appKey
    headerParam["X-ROLENAME"] = exchangeXROLENAME(url);
    headerParam["X-ORG"] = window.localStorage.getItem('currentOrg');
    headerParam["X-SURROGATE"] = this.matchSurrogate(window.localStorage.getItem('userOrgList'), window.localStorage.getItem('currentOrg'));

    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: IEBrowserUrl(url),
        withCredentials: false,
        params: params,
        data: data,
        headers: headerParam
      }).then(resp => {
        resolve(resp)
      }).catch(error => {
        reject(error)
      })
    })
  },
  axiosGet(url) {
    // url += (url.indexOf("?") !== -1) ? "&" : "?";
    // url += "apiKey=inventory-xkZzPkbrL1vDjHM1";
    // url += '&t=' + new Date().getTime();
    //
    // params = params == null ? {} : params;
    // params.token = 'PgTT0stft9qA7JGJp7f0oWT7j7pJ046j'
    // url += '&sign=' + util.generateGetSign(params,url);

    //	url = util.encodeSplitUrl(url);

    let headerParam = {};

//		 let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
//		 headerParam.Authorization = 'Bearer ' + userInfo.access_token;
    let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    // if (window.baseSSO.environment !== 'local') {
    //   headerParam.Authorization = 'Bearer ' + userInfo.access_token;
    // }
    headerParam.Authorization = 'Bearer ' + userInfo.access_token;
    headerParam["REQUEST-ID"] = util.generateUUID();
//		 headerParam["X-USERNAME"] = userInfo.username;
    headerParam["X-USERNAME"] = store.getters.getUsername;
    headerParam["Ocp-Apim-Subscription-Key"] = util.decrypt(window.localStorage.getItem('subscriptionKey'));
    headerParam["Auth-Type"] = window.localStorage.getItem('authType');
    headerParam["appKey"] = window.BaseConfigInfo.baseSSO.appKey
    headerParam["X-ROLENAME"] = exchangeXROLENAME(url);
    headerParam["X-ORG"] = window.localStorage.getItem('currentOrg');
    headerParam["X-SURROGATE"] = this.matchSurrogate(window.localStorage.getItem('userOrgList'), window.localStorage.getItem('currentOrg'));

    // headerParam["content-type"] = 'application/json;charset=UTF-8';
    //请求远端
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: IEBrowserUrl(url),
        headers: headerParam
      }).then(resp => {
        resolve(resp)
      }).catch(error => {
        reject(error)
      })
    })
  },

  fileUpload(url, data) {
    let headerParam = {};
    let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    headerParam["Content-Type"] = "multipart/form-data";
    headerParam["X-USERNAME"] = store.getters.getUsername;
    headerParam["appKey"] = window.BaseConfigInfo.baseSSO.appKey
    headerParam["X-ROLENAME"] = exchangeXROLENAME(url);
    headerParam["X-ORG"] = window.localStorage.getItem('currentOrg');
    headerParam["X-SURROGATE"] = this.matchSurrogate(window.localStorage.getItem('userOrgList'), window.localStorage.getItem('currentOrg'));

    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: IEBrowserUrl(url),
        withCredentials: false,
        data: data,
        headers: headerParam
      }).then(resp => {
        resolve(resp)
      }).catch(error => {
        reject(error)
      })
    })
  },
  refreshToken(url, data, params) {
    params = params == null ? {} : params;
    url += (url.indexOf("?") !== -1) ? "&" : "?";
    url += "api_key=" + window.localStorage.getItem('apiKey');
    url += '&timestamp=' + new Date().toISOString().replace('T', ' ').slice(0, -5);
    url += '&nonce_str=' + util.generateUUID();

    params.sign = util.generatePostJsonSign(params, url, data);


    url = util.encodeSplitUrl(url);
    //生成sign后删除token
    delete params.token;
    let headerParam = {};
    headerParam["content-type"] = 'application/json;charset=UTF-8';
    let userInfo = window.localStorage.getItem('userInfo');
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      if (window.baseSSO.environment !== 'local') {
        headerParam.Authorization = 'Bearer ' + userInfo.access_token;
      }
    }
    headerParam["REQUEST-ID"] = util.generateUUID();
    let subscriptionKey = url.indexOf(window.BaseConfigInfo.baseSSOShared.refresh_token_url) !== -1
      ? window.BaseConfigInfo.baseSSOShared.subscription_key
      : util.decrypt(window.baseSSO.dimension2);
    headerParam["Ocp-Apim-Subscription-Key"] = subscriptionKey;
    headerParam["Auth-Type"] = window.localStorage.getItem('authType');
    headerParam["appKey"] = window.BaseConfigInfo.baseSSO.appKey
    headerParam["X-ROLENAME"] = exchangeXROLENAME(url);
    headerParam["X-ORG"] = window.localStorage.getItem('currentOrg');
    headerParam["X-SURROGATE"] = this.matchSurrogate(window.localStorage.getItem('userOrgList'), window.localStorage.getItem('currentOrg'));

    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: IEBrowserUrl(url),
        withCredentials: false,
        params: params,
        data: data,
        headers: headerParam
      }).then(resp => {
        resolve(resp)
      }).catch(error => {
        reject(error)
      })
    })
  },
  matchSurrogate(orgList, currentOrg) {
    let isSurrogate = false;
    const currentRole = window.localStorage.getItem('currentRole');
    if (orgList) {
      orgList = JSON.parse(orgList);
      if(orgList && orgList.length > 0) {
        let org = orgList.find(function(item) {
          return item.orgCode === currentOrg && item.role === currentRole;
        }) 
        if(org && org.surrogate) {
          isSurrogate = org.surrogate;
        }
      }
    }
    return isSurrogate;
  },
  async mpExportData(url, data, params = {}, cancelToken = null) {
    params = util.deepClone(params);
    url += (url.indexOf("?") !== -1) ? "&" : "?";
    url += "api_key=" + window.localStorage.getItem('apiKey');
    url += '&timestamp=' + new Date().toISOString().replace('T', ' ').slice(0, -5);
    url += '&nonce_str=' + util.generateUUID();
    // url = util.splitUrl(params, url);
    params.sign = util.generatePostJsonSign(params, url, data);


    url = util.encodeSplitUrl(url);
    //生成sign后删除token
    delete params.token;
    let headerParam = {};
    headerParam["content-type"] = 'application/json;charset=UTF-8';
    let userInfo = window.localStorage.getItem('userInfo');
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      // if (window.baseSSO.environment !== 'local') {
      //   headerParam.Authorization = 'Bearer ' + userInfo.access_token;
      // }
      headerParam.Authorization = 'Bearer ' + userInfo.access_token;
      headerParam["X-USERNAME"] = userInfo.username;
    } else {
      headerParam["X-USERNAME"] = window.localStorage.getItem('username');
    }
    headerParam["REQUEST-ID"] = util.generateUUID();
    headerParam["Ocp-Apim-Subscription-Key"] = util.decrypt(window.localStorage.getItem('subscriptionKey'));
    headerParam["Auth-Type"] = window.localStorage.getItem('authType');
    headerParam["appKey"] = window.BaseConfigInfo.baseSSO.appKey
    headerParam["X-ROLENAME"] = exchangeXROLENAME(url);
    headerParam["X-ORG"] = window.localStorage.getItem('currentOrg');
    headerParam["X-SURROGATE"] = this.matchSurrogate(window.localStorage.getItem('userOrgList'), window.localStorage.getItem('currentOrg'));
    headerParam["mp-export-data"] = true;
    let httpParam = {
      method: 'post',
      url: IEBrowserUrl(url),
      withCredentials: false,
      params: params,
      data: data,
      headers: headerParam,
      responseType: 'blob',
    };
    if (cancelToken) {
      httpParam["cancelToken"] = cancelToken;
    }
    const resp = await axios(httpParam)
    fileDownload(resp)


    // return new Promise((resolve, reject) => {
    //   axios(httpParam).then(resp => {
    //     resolve(resp)
    //   }).catch(error => {
    //     reject(error)
    //   })
    // })
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/http/via-axios.js